// ----------------------------------------------------------------------

export default function Stack() {
  return {
    MuiStack: {
      defaultProps: {
        useFlexGap: true,
      },
    },
  };
}
